const useValue = (el) => {
    const notCheckable = el.type !== "radio" && el.type !== "checkbox";

    return notCheckable || el.checked;
};

const extractProps = ({elements}) => elements && Array.prototype.reduce.call(
    elements,
    (props, el) => {
        if (el.name && el.value && useValue(el)) {
            props.defaults[el.name] = el.value;
        } else if (el.type === "checkbox") {
            props.defaults[el.name] = el.checked;
        }

        if (el.hasAttribute("data-error-msg")) {
            props.errors = props.errors.concat(
                el.getAttribute("data-error-msg")
                    .split(" | ")
                    .map(message => ({
                        name: el.name,
                        message,
                    }))
            );
        }

        return props;
    },
    {
        defaults: {},
        errors: [],
    }
);

export default extractProps;